import React, { useState, useEffect } from 'react';
import styles from './TemplateHero5.module.css';

const TemplateHero5 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides
  const slides = heroData?.slides || [];

  // Auto-play slider logic (Standard logic)
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      
      {/* Background Images with Zigzag Mask */}
      <div className={styles.imageColumn}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
            style={{ backgroundImage: `url('${slide.image}')` }}
          >
            <div className={styles.imageOverlay}></div>
          </div>
        ))}
      </div>

      {/* Zigzag Border Element */}
      <div className={styles.zigzagDivider}></div>

      {/* Content Side */}
      <div className={styles.contentSide}>
        <div className={styles.contentWrapper} key={`zigzag-${currentSlide}`}>
          <div className={styles.tagLine}>
            <span className={styles.line}></span>
            <span className={styles.tagText}>New Perspective</span>
          </div>

          <h1 className={styles.title}>
            {slides[currentSlide].title}
          </h1>

          <p className={styles.subtitle}>
            {slides[currentSlide].subtitle}
          </p>

          <div className={styles.btnGroup}>
            <button className={styles.primaryBtn}>
              Explore Now
            </button>
            <button className={styles.outlineBtn}>
              View Case Study
            </button>
          </div>
        </div>
      </div>

      {/* Square Indicators (Bottom Right) */}
      {slides.length > 1 && (
        <div className={styles.squareNav}>
          {slides.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.square} ${index === currentSlide ? styles.activeSquare : ''}`}
            >
              <div className={styles.squareInner}></div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default TemplateHero5;